import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { StarDisplay } from '../productReview/StarRating';

const Item = ({ id, image, stock, hasDiscount, discountedPrice, discountBadge, name, price, averageRating, reviewCount, onClick }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleClick = () => {
    if (onClick) onClick(id);
  };

  return (
    <Link 
      to={`/product/${id}`}
      className="group block cursor-pointer"
      onClick={handleClick}
    >
      <div className='relative w-full'>
        
        {/* --- IMAGE FRAME --- */}
        <div className='relative aspect-[4/5] overflow-hidden bg-gray-50 p-6'>
          
          {/* Discount Tag - Kept Minimal */}
          {hasDiscount && stock > 0 && (
            <div className='absolute top-0 left-0 z-20'>
              <div className='bg-white px-3 py-2 border-r border-b border-gray-100'>
                <span className='block text-[9px] uppercase tracking-[0.2em] font-medium text-black'>
                  -{discountBadge}
                </span>
              </div>
            </div>
          )}
          
          {/* Main Image */}
          <img 
            src={image} 
            alt={name}
            loading='lazy'
            decoding='async'
            onLoad={() => setImageLoaded(true)}
            className={`
              w-full h-full object-contain mix-blend-multiply
              transition-all duration-700 ease-out
              ${imageLoaded ? 'opacity-100' : 'opacity-0'}
              ${stock === 0 ? 'opacity-40 grayscale' : 'group-hover:scale-105'}
            `}
            style={{ transformOrigin: 'center center' }}
          />

          {/* Waitlist Overlay */}
          {stock === 0 && (
            <div className='absolute inset-0 flex items-center justify-center z-10'>
              <div className='bg-white/90 backdrop-blur-[2px] px-6 py-3 border border-black/5'>
                <span className='block text-[10px] uppercase tracking-[0.3em] text-black'>
                  Waitlist
                </span>
              </div>
            </div>
          )}
        </div>
        
        {/* --- TEXT CONTENT --- */}
        <div className='pt-6 pb-2 text-center'>
          
          {/* Product Name */}
          <h3 className='font-serif text-xl text-black mb-1.5 font-normal tracking-tight group-hover:text-gray-600 transition-colors'>
            {name}
          </h3>
          
          {/* Price Area - The Fix */}
          <div className='flex items-center justify-center gap-3'>
            {hasDiscount && stock > 0 ? (
              <>
                <span className='text-xs text-gray-400 line-through decoration-gray-300 font-light'>
                  ${price}
                </span>
                <span className='text-sm text-black font-medium tracking-wide'>
                  ${discountedPrice}
                </span>
              </>
            ) : (
              <span className='text-sm text-black/80 font-light tracking-wide'>
                ${price}
              </span>
            )}
          </div>

          {/* Rating - only once a product has been reviewed */}
          {reviewCount > 0 && (
            <div className='flex items-center justify-center gap-2 mt-2'>
              <StarDisplay value={averageRating} size='text-xs' />
              <span className='text-[10px] text-gray-400 tabular-nums'>({reviewCount})</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default React.memo(Item);